import React, { useRef } from 'react';
import { StyleSheet, View } from 'react-native';
import { FormContainer, Input, ButtonContainer, Button } from '../Form';
import { themeForm } from '../../styles';

export const ApiHost = () => {
  const apiHostRef = useRef<HTMLInputElement>(null);

  const handleSave = () => {
    if (apiHostRef.current?.value) {
      sessionStorage.setItem('apiHost', apiHostRef.current?.value);
      window.location.reload();
    }
  };

  return (
    <View style={styles.container}>
      <FormContainer title="API Host" style={[themeForm.center]}>
        <Input ref={apiHostRef} value={sessionStorage.getItem('apiHost')} id="apiHost" label="API Host" />
        <ButtonContainer direction="vertical">
          <Button onPress={handleSave}>Save</Button>
        </ButtonContainer>
      </FormContainer>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {},
});
